module.exports = __webpack_public_path__ + "img/hr-heat-pipe-ending-up-1.5354268f.png";